/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as LocalePartnerRouteRouteImport } from './routes/$locale/$partner/route'
import { Route as LocaleErrorRouteImport } from './routes/$locale/error'
import { Route as LocalePartnerAppRouteRouteImport } from './routes/$locale/$partner/_app/route'
import { Route as LocalePartnerPeerRouteImport } from './routes/$locale/$partner/peer'
import { Route as LocalePartnerAppIndexRouteImport } from './routes/$locale/$partner/_app/index'
import { Route as LocalePartnerAppCardRouteRouteImport } from './routes/$locale/$partner/_app/_card/route'
import { Route as LocalePartnerAppCardPairedRouteRouteImport } from './routes/$locale/$partner/_app/_card/_paired/route'
import { Route as LocalePartnerAppCardDeviceRoleInstructionsRouteImport } from './routes/$locale/$partner/_app/_card/device-role-instructions'
import { Route as LocalePartnerAppCardImeiInstructionsRouteImport } from './routes/$locale/$partner/_app/_card/imei-instructions'
import { Route as LocalePartnerAppCardImeiScanRouteImport } from './routes/$locale/$partner/_app/_card/imei-scan'
import { Route as LocalePartnerAppCardInstructionsRouteImport } from './routes/$locale/$partner/_app/_card/instructions'
import { Route as LocalePartnerAppCardMaxPriceRouteImport } from './routes/$locale/$partner/_app/_card/max-price'
import { Route as LocalePartnerAppCardPairScannerDeviceRouteImport } from './routes/$locale/$partner/_app/_card/pair-scanner-device'
import { Route as LocalePartnerAppCardPrepareScannerDeviceRouteImport } from './routes/$locale/$partner/_app/_card/prepare-scanner-device'
import { Route as LocalePartnerAppCardQuoteVsEstimateRouteImport } from './routes/$locale/$partner/_app/_card/quote-vs-estimate'
import { Route as LocalePartnerAppCardSelectScannerDeviceRouteImport } from './routes/$locale/$partner/_app/_card/select-scanner-device'
import { Route as LocalePartnerAppCardUserInfoRouteImport } from './routes/$locale/$partner/_app/_card/user-info'
import { Route as LocalePartnerAppCardPairedDeviceGradingRouteImport } from './routes/$locale/$partner/_app/_card/_paired/device-grading'
import { Route as LocalePartnerAppCardPairedDevicePairingRouteImport } from './routes/$locale/$partner/_app/_card/_paired/device-pairing'
import { Route as LocalePartnerAppCardPairedImageCaptureRouteImport } from './routes/$locale/$partner/_app/_card/_paired/image-capture'
import { Route as LocalePartnerAppCardPairedOfferRouteImport } from './routes/$locale/$partner/_app/_card/_paired/offer'
import { Route as LocalePartnerAppCardPairedPaymentMethodsRouteImport } from './routes/$locale/$partner/_app/_card/_paired/payment-methods'
import { Route as LocalePartnerAppCardPairedProcessCompletedRouteImport } from './routes/$locale/$partner/_app/_card/_paired/process-completed'
import { Route as LocalePartnerAppCardPairedRedirectionRouteImport } from './routes/$locale/$partner/_app/_card/_paired/redirection'
import { Route as LocalePartnerAppCardPairedWebappAssessmentRouteImport } from './routes/$locale/$partner/_app/_card/_paired/webapp-assessment'

const LocaleRouteRoute = LocaleRouteRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const LocalePartnerRouteRoute = LocalePartnerRouteRouteImport.update({
  id: '/$partner',
  path: '/$partner',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleErrorRoute = LocaleErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocalePartnerAppRouteRoute = LocalePartnerAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerPeerRoute = LocalePartnerPeerRouteImport.update({
  id: '/peer',
  path: '/peer',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerAppIndexRoute = LocalePartnerAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocalePartnerAppRouteRoute,
} as any)
const LocalePartnerAppCardRouteRoute =
  LocalePartnerAppCardRouteRouteImport.update({
    id: '/_card',
    getParentRoute: () => LocalePartnerAppRouteRoute,
  } as any)
const LocalePartnerAppCardPairedRouteRoute =
  LocalePartnerAppCardPairedRouteRouteImport.update({
    id: '/_paired',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardDeviceRoleInstructionsRoute =
  LocalePartnerAppCardDeviceRoleInstructionsRouteImport.update({
    id: '/device-role-instructions',
    path: '/device-role-instructions',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardImeiInstructionsRoute =
  LocalePartnerAppCardImeiInstructionsRouteImport.update({
    id: '/imei-instructions',
    path: '/imei-instructions',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardImeiScanRoute =
  LocalePartnerAppCardImeiScanRouteImport.update({
    id: '/imei-scan',
    path: '/imei-scan',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardInstructionsRoute =
  LocalePartnerAppCardInstructionsRouteImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardMaxPriceRoute =
  LocalePartnerAppCardMaxPriceRouteImport.update({
    id: '/max-price',
    path: '/max-price',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardPairScannerDeviceRoute =
  LocalePartnerAppCardPairScannerDeviceRouteImport.update({
    id: '/pair-scanner-device',
    path: '/pair-scanner-device',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardPrepareScannerDeviceRoute =
  LocalePartnerAppCardPrepareScannerDeviceRouteImport.update({
    id: '/prepare-scanner-device',
    path: '/prepare-scanner-device',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardQuoteVsEstimateRoute =
  LocalePartnerAppCardQuoteVsEstimateRouteImport.update({
    id: '/quote-vs-estimate',
    path: '/quote-vs-estimate',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardSelectScannerDeviceRoute =
  LocalePartnerAppCardSelectScannerDeviceRouteImport.update({
    id: '/select-scanner-device',
    path: '/select-scanner-device',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardUserInfoRoute =
  LocalePartnerAppCardUserInfoRouteImport.update({
    id: '/user-info',
    path: '/user-info',
    getParentRoute: () => LocalePartnerAppCardRouteRoute,
  } as any)
const LocalePartnerAppCardPairedDeviceGradingRoute =
  LocalePartnerAppCardPairedDeviceGradingRouteImport.update({
    id: '/device-grading',
    path: '/device-grading',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedDevicePairingRoute =
  LocalePartnerAppCardPairedDevicePairingRouteImport.update({
    id: '/device-pairing',
    path: '/device-pairing',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedImageCaptureRoute =
  LocalePartnerAppCardPairedImageCaptureRouteImport.update({
    id: '/image-capture',
    path: '/image-capture',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedOfferRoute =
  LocalePartnerAppCardPairedOfferRouteImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedPaymentMethodsRoute =
  LocalePartnerAppCardPairedPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedProcessCompletedRoute =
  LocalePartnerAppCardPairedProcessCompletedRouteImport.update({
    id: '/process-completed',
    path: '/process-completed',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedRedirectionRoute =
  LocalePartnerAppCardPairedRedirectionRouteImport.update({
    id: '/redirection',
    path: '/redirection',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)
const LocalePartnerAppCardPairedWebappAssessmentRoute =
  LocalePartnerAppCardPairedWebappAssessmentRouteImport.update({
    id: '/webapp-assessment',
    path: '/webapp-assessment',
    getParentRoute: () => LocalePartnerAppCardPairedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/error': typeof LocaleErrorRoute
  '/$locale/$partner/peer': typeof LocalePartnerPeerRoute
  '/$locale/$partner/': typeof LocalePartnerAppIndexRoute
  '/$locale/$partner/device-role-instructions': typeof LocalePartnerAppCardDeviceRoleInstructionsRoute
  '/$locale/$partner/imei-instructions': typeof LocalePartnerAppCardImeiInstructionsRoute
  '/$locale/$partner/imei-scan': typeof LocalePartnerAppCardImeiScanRoute
  '/$locale/$partner/instructions': typeof LocalePartnerAppCardInstructionsRoute
  '/$locale/$partner/max-price': typeof LocalePartnerAppCardMaxPriceRoute
  '/$locale/$partner/pair-scanner-device': typeof LocalePartnerAppCardPairScannerDeviceRoute
  '/$locale/$partner/prepare-scanner-device': typeof LocalePartnerAppCardPrepareScannerDeviceRoute
  '/$locale/$partner/quote-vs-estimate': typeof LocalePartnerAppCardQuoteVsEstimateRoute
  '/$locale/$partner/select-scanner-device': typeof LocalePartnerAppCardSelectScannerDeviceRoute
  '/$locale/$partner/user-info': typeof LocalePartnerAppCardUserInfoRoute
  '/$locale/$partner/device-grading': typeof LocalePartnerAppCardPairedDeviceGradingRoute
  '/$locale/$partner/device-pairing': typeof LocalePartnerAppCardPairedDevicePairingRoute
  '/$locale/$partner/image-capture': typeof LocalePartnerAppCardPairedImageCaptureRoute
  '/$locale/$partner/offer': typeof LocalePartnerAppCardPairedOfferRoute
  '/$locale/$partner/payment-methods': typeof LocalePartnerAppCardPairedPaymentMethodsRoute
  '/$locale/$partner/process-completed': typeof LocalePartnerAppCardPairedProcessCompletedRoute
  '/$locale/$partner/redirection': typeof LocalePartnerAppCardPairedRedirectionRoute
  '/$locale/$partner/webapp-assessment': typeof LocalePartnerAppCardPairedWebappAssessmentRoute
}
export interface FileRoutesByTo {
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerAppIndexRoute
  '/$locale/error': typeof LocaleErrorRoute
  '/$locale/$partner/peer': typeof LocalePartnerPeerRoute
  '/$locale/$partner/device-role-instructions': typeof LocalePartnerAppCardDeviceRoleInstructionsRoute
  '/$locale/$partner/imei-instructions': typeof LocalePartnerAppCardImeiInstructionsRoute
  '/$locale/$partner/imei-scan': typeof LocalePartnerAppCardImeiScanRoute
  '/$locale/$partner/instructions': typeof LocalePartnerAppCardInstructionsRoute
  '/$locale/$partner/max-price': typeof LocalePartnerAppCardMaxPriceRoute
  '/$locale/$partner/pair-scanner-device': typeof LocalePartnerAppCardPairScannerDeviceRoute
  '/$locale/$partner/prepare-scanner-device': typeof LocalePartnerAppCardPrepareScannerDeviceRoute
  '/$locale/$partner/quote-vs-estimate': typeof LocalePartnerAppCardQuoteVsEstimateRoute
  '/$locale/$partner/select-scanner-device': typeof LocalePartnerAppCardSelectScannerDeviceRoute
  '/$locale/$partner/user-info': typeof LocalePartnerAppCardUserInfoRoute
  '/$locale/$partner/device-grading': typeof LocalePartnerAppCardPairedDeviceGradingRoute
  '/$locale/$partner/device-pairing': typeof LocalePartnerAppCardPairedDevicePairingRoute
  '/$locale/$partner/image-capture': typeof LocalePartnerAppCardPairedImageCaptureRoute
  '/$locale/$partner/offer': typeof LocalePartnerAppCardPairedOfferRoute
  '/$locale/$partner/payment-methods': typeof LocalePartnerAppCardPairedPaymentMethodsRoute
  '/$locale/$partner/process-completed': typeof LocalePartnerAppCardPairedProcessCompletedRoute
  '/$locale/$partner/redirection': typeof LocalePartnerAppCardPairedRedirectionRoute
  '/$locale/$partner/webapp-assessment': typeof LocalePartnerAppCardPairedWebappAssessmentRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/error': typeof LocaleErrorRoute
  '/$locale/$partner/_app': typeof LocalePartnerAppRouteRouteWithChildren
  '/$locale/$partner/peer': typeof LocalePartnerPeerRoute
  '/$locale/$partner/_app/_card': typeof LocalePartnerAppCardRouteRouteWithChildren
  '/$locale/$partner/_app/': typeof LocalePartnerAppIndexRoute
  '/$locale/$partner/_app/_card/_paired': typeof LocalePartnerAppCardPairedRouteRouteWithChildren
  '/$locale/$partner/_app/_card/device-role-instructions': typeof LocalePartnerAppCardDeviceRoleInstructionsRoute
  '/$locale/$partner/_app/_card/imei-instructions': typeof LocalePartnerAppCardImeiInstructionsRoute
  '/$locale/$partner/_app/_card/imei-scan': typeof LocalePartnerAppCardImeiScanRoute
  '/$locale/$partner/_app/_card/instructions': typeof LocalePartnerAppCardInstructionsRoute
  '/$locale/$partner/_app/_card/max-price': typeof LocalePartnerAppCardMaxPriceRoute
  '/$locale/$partner/_app/_card/pair-scanner-device': typeof LocalePartnerAppCardPairScannerDeviceRoute
  '/$locale/$partner/_app/_card/prepare-scanner-device': typeof LocalePartnerAppCardPrepareScannerDeviceRoute
  '/$locale/$partner/_app/_card/quote-vs-estimate': typeof LocalePartnerAppCardQuoteVsEstimateRoute
  '/$locale/$partner/_app/_card/select-scanner-device': typeof LocalePartnerAppCardSelectScannerDeviceRoute
  '/$locale/$partner/_app/_card/user-info': typeof LocalePartnerAppCardUserInfoRoute
  '/$locale/$partner/_app/_card/_paired/device-grading': typeof LocalePartnerAppCardPairedDeviceGradingRoute
  '/$locale/$partner/_app/_card/_paired/device-pairing': typeof LocalePartnerAppCardPairedDevicePairingRoute
  '/$locale/$partner/_app/_card/_paired/image-capture': typeof LocalePartnerAppCardPairedImageCaptureRoute
  '/$locale/$partner/_app/_card/_paired/offer': typeof LocalePartnerAppCardPairedOfferRoute
  '/$locale/$partner/_app/_card/_paired/payment-methods': typeof LocalePartnerAppCardPairedPaymentMethodsRoute
  '/$locale/$partner/_app/_card/_paired/process-completed': typeof LocalePartnerAppCardPairedProcessCompletedRoute
  '/$locale/$partner/_app/_card/_paired/redirection': typeof LocalePartnerAppCardPairedRedirectionRoute
  '/$locale/$partner/_app/_card/_paired/webapp-assessment': typeof LocalePartnerAppCardPairedWebappAssessmentRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/error'
    | '/$locale/$partner/peer'
    | '/$locale/$partner/'
    | '/$locale/$partner/device-role-instructions'
    | '/$locale/$partner/imei-instructions'
    | '/$locale/$partner/imei-scan'
    | '/$locale/$partner/instructions'
    | '/$locale/$partner/max-price'
    | '/$locale/$partner/pair-scanner-device'
    | '/$locale/$partner/prepare-scanner-device'
    | '/$locale/$partner/quote-vs-estimate'
    | '/$locale/$partner/select-scanner-device'
    | '/$locale/$partner/user-info'
    | '/$locale/$partner/device-grading'
    | '/$locale/$partner/device-pairing'
    | '/$locale/$partner/image-capture'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/payment-methods'
    | '/$locale/$partner/process-completed'
    | '/$locale/$partner/redirection'
    | '/$locale/$partner/webapp-assessment'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/error'
    | '/$locale/$partner/peer'
    | '/$locale/$partner/device-role-instructions'
    | '/$locale/$partner/imei-instructions'
    | '/$locale/$partner/imei-scan'
    | '/$locale/$partner/instructions'
    | '/$locale/$partner/max-price'
    | '/$locale/$partner/pair-scanner-device'
    | '/$locale/$partner/prepare-scanner-device'
    | '/$locale/$partner/quote-vs-estimate'
    | '/$locale/$partner/select-scanner-device'
    | '/$locale/$partner/user-info'
    | '/$locale/$partner/device-grading'
    | '/$locale/$partner/device-pairing'
    | '/$locale/$partner/image-capture'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/payment-methods'
    | '/$locale/$partner/process-completed'
    | '/$locale/$partner/redirection'
    | '/$locale/$partner/webapp-assessment'
  id:
    | '__root__'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/error'
    | '/$locale/$partner/_app'
    | '/$locale/$partner/peer'
    | '/$locale/$partner/_app/_card'
    | '/$locale/$partner/_app/'
    | '/$locale/$partner/_app/_card/_paired'
    | '/$locale/$partner/_app/_card/device-role-instructions'
    | '/$locale/$partner/_app/_card/imei-instructions'
    | '/$locale/$partner/_app/_card/imei-scan'
    | '/$locale/$partner/_app/_card/instructions'
    | '/$locale/$partner/_app/_card/max-price'
    | '/$locale/$partner/_app/_card/pair-scanner-device'
    | '/$locale/$partner/_app/_card/prepare-scanner-device'
    | '/$locale/$partner/_app/_card/quote-vs-estimate'
    | '/$locale/$partner/_app/_card/select-scanner-device'
    | '/$locale/$partner/_app/_card/user-info'
    | '/$locale/$partner/_app/_card/_paired/device-grading'
    | '/$locale/$partner/_app/_card/_paired/device-pairing'
    | '/$locale/$partner/_app/_card/_paired/image-capture'
    | '/$locale/$partner/_app/_card/_paired/offer'
    | '/$locale/$partner/_app/_card/_paired/payment-methods'
    | '/$locale/$partner/_app/_card/_paired/process-completed'
    | '/$locale/$partner/_app/_card/_paired/redirection'
    | '/$locale/$partner/_app/_card/_paired/webapp-assessment'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LocaleRouteRoute: typeof LocaleRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$partner': {
      id: '/$locale/$partner'
      path: '/$partner'
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerRouteRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/error': {
      id: '/$locale/error'
      path: '/error'
      fullPath: '/$locale/error'
      preLoaderRoute: typeof LocaleErrorRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$partner/_app': {
      id: '/$locale/$partner/_app'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerAppRouteRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/peer': {
      id: '/$locale/$partner/peer'
      path: '/peer'
      fullPath: '/$locale/$partner/peer'
      preLoaderRoute: typeof LocalePartnerPeerRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/_app/': {
      id: '/$locale/$partner/_app/'
      path: '/'
      fullPath: '/$locale/$partner/'
      preLoaderRoute: typeof LocalePartnerAppIndexRouteImport
      parentRoute: typeof LocalePartnerAppRouteRoute
    }
    '/$locale/$partner/_app/_card': {
      id: '/$locale/$partner/_app/_card'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerAppCardRouteRouteImport
      parentRoute: typeof LocalePartnerAppRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired': {
      id: '/$locale/$partner/_app/_card/_paired'
      path: ''
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerAppCardPairedRouteRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/device-role-instructions': {
      id: '/$locale/$partner/_app/_card/device-role-instructions'
      path: '/device-role-instructions'
      fullPath: '/$locale/$partner/device-role-instructions'
      preLoaderRoute: typeof LocalePartnerAppCardDeviceRoleInstructionsRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/imei-instructions': {
      id: '/$locale/$partner/_app/_card/imei-instructions'
      path: '/imei-instructions'
      fullPath: '/$locale/$partner/imei-instructions'
      preLoaderRoute: typeof LocalePartnerAppCardImeiInstructionsRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/imei-scan': {
      id: '/$locale/$partner/_app/_card/imei-scan'
      path: '/imei-scan'
      fullPath: '/$locale/$partner/imei-scan'
      preLoaderRoute: typeof LocalePartnerAppCardImeiScanRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/instructions': {
      id: '/$locale/$partner/_app/_card/instructions'
      path: '/instructions'
      fullPath: '/$locale/$partner/instructions'
      preLoaderRoute: typeof LocalePartnerAppCardInstructionsRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/max-price': {
      id: '/$locale/$partner/_app/_card/max-price'
      path: '/max-price'
      fullPath: '/$locale/$partner/max-price'
      preLoaderRoute: typeof LocalePartnerAppCardMaxPriceRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/pair-scanner-device': {
      id: '/$locale/$partner/_app/_card/pair-scanner-device'
      path: '/pair-scanner-device'
      fullPath: '/$locale/$partner/pair-scanner-device'
      preLoaderRoute: typeof LocalePartnerAppCardPairScannerDeviceRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/prepare-scanner-device': {
      id: '/$locale/$partner/_app/_card/prepare-scanner-device'
      path: '/prepare-scanner-device'
      fullPath: '/$locale/$partner/prepare-scanner-device'
      preLoaderRoute: typeof LocalePartnerAppCardPrepareScannerDeviceRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/quote-vs-estimate': {
      id: '/$locale/$partner/_app/_card/quote-vs-estimate'
      path: '/quote-vs-estimate'
      fullPath: '/$locale/$partner/quote-vs-estimate'
      preLoaderRoute: typeof LocalePartnerAppCardQuoteVsEstimateRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/select-scanner-device': {
      id: '/$locale/$partner/_app/_card/select-scanner-device'
      path: '/select-scanner-device'
      fullPath: '/$locale/$partner/select-scanner-device'
      preLoaderRoute: typeof LocalePartnerAppCardSelectScannerDeviceRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/user-info': {
      id: '/$locale/$partner/_app/_card/user-info'
      path: '/user-info'
      fullPath: '/$locale/$partner/user-info'
      preLoaderRoute: typeof LocalePartnerAppCardUserInfoRouteImport
      parentRoute: typeof LocalePartnerAppCardRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/device-grading': {
      id: '/$locale/$partner/_app/_card/_paired/device-grading'
      path: '/device-grading'
      fullPath: '/$locale/$partner/device-grading'
      preLoaderRoute: typeof LocalePartnerAppCardPairedDeviceGradingRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/device-pairing': {
      id: '/$locale/$partner/_app/_card/_paired/device-pairing'
      path: '/device-pairing'
      fullPath: '/$locale/$partner/device-pairing'
      preLoaderRoute: typeof LocalePartnerAppCardPairedDevicePairingRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/image-capture': {
      id: '/$locale/$partner/_app/_card/_paired/image-capture'
      path: '/image-capture'
      fullPath: '/$locale/$partner/image-capture'
      preLoaderRoute: typeof LocalePartnerAppCardPairedImageCaptureRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/offer': {
      id: '/$locale/$partner/_app/_card/_paired/offer'
      path: '/offer'
      fullPath: '/$locale/$partner/offer'
      preLoaderRoute: typeof LocalePartnerAppCardPairedOfferRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/payment-methods': {
      id: '/$locale/$partner/_app/_card/_paired/payment-methods'
      path: '/payment-methods'
      fullPath: '/$locale/$partner/payment-methods'
      preLoaderRoute: typeof LocalePartnerAppCardPairedPaymentMethodsRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/process-completed': {
      id: '/$locale/$partner/_app/_card/_paired/process-completed'
      path: '/process-completed'
      fullPath: '/$locale/$partner/process-completed'
      preLoaderRoute: typeof LocalePartnerAppCardPairedProcessCompletedRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/redirection': {
      id: '/$locale/$partner/_app/_card/_paired/redirection'
      path: '/redirection'
      fullPath: '/$locale/$partner/redirection'
      preLoaderRoute: typeof LocalePartnerAppCardPairedRedirectionRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
    '/$locale/$partner/_app/_card/_paired/webapp-assessment': {
      id: '/$locale/$partner/_app/_card/_paired/webapp-assessment'
      path: '/webapp-assessment'
      fullPath: '/$locale/$partner/webapp-assessment'
      preLoaderRoute: typeof LocalePartnerAppCardPairedWebappAssessmentRouteImport
      parentRoute: typeof LocalePartnerAppCardPairedRouteRoute
    }
  }
}

interface LocalePartnerAppCardPairedRouteRouteChildren {
  LocalePartnerAppCardPairedDeviceGradingRoute: typeof LocalePartnerAppCardPairedDeviceGradingRoute
  LocalePartnerAppCardPairedDevicePairingRoute: typeof LocalePartnerAppCardPairedDevicePairingRoute
  LocalePartnerAppCardPairedImageCaptureRoute: typeof LocalePartnerAppCardPairedImageCaptureRoute
  LocalePartnerAppCardPairedOfferRoute: typeof LocalePartnerAppCardPairedOfferRoute
  LocalePartnerAppCardPairedPaymentMethodsRoute: typeof LocalePartnerAppCardPairedPaymentMethodsRoute
  LocalePartnerAppCardPairedProcessCompletedRoute: typeof LocalePartnerAppCardPairedProcessCompletedRoute
  LocalePartnerAppCardPairedRedirectionRoute: typeof LocalePartnerAppCardPairedRedirectionRoute
  LocalePartnerAppCardPairedWebappAssessmentRoute: typeof LocalePartnerAppCardPairedWebappAssessmentRoute
}

const LocalePartnerAppCardPairedRouteRouteChildren: LocalePartnerAppCardPairedRouteRouteChildren =
  {
    LocalePartnerAppCardPairedDeviceGradingRoute:
      LocalePartnerAppCardPairedDeviceGradingRoute,
    LocalePartnerAppCardPairedDevicePairingRoute:
      LocalePartnerAppCardPairedDevicePairingRoute,
    LocalePartnerAppCardPairedImageCaptureRoute:
      LocalePartnerAppCardPairedImageCaptureRoute,
    LocalePartnerAppCardPairedOfferRoute: LocalePartnerAppCardPairedOfferRoute,
    LocalePartnerAppCardPairedPaymentMethodsRoute:
      LocalePartnerAppCardPairedPaymentMethodsRoute,
    LocalePartnerAppCardPairedProcessCompletedRoute:
      LocalePartnerAppCardPairedProcessCompletedRoute,
    LocalePartnerAppCardPairedRedirectionRoute:
      LocalePartnerAppCardPairedRedirectionRoute,
    LocalePartnerAppCardPairedWebappAssessmentRoute:
      LocalePartnerAppCardPairedWebappAssessmentRoute,
  }

const LocalePartnerAppCardPairedRouteRouteWithChildren =
  LocalePartnerAppCardPairedRouteRoute._addFileChildren(
    LocalePartnerAppCardPairedRouteRouteChildren,
  )

interface LocalePartnerAppCardRouteRouteChildren {
  LocalePartnerAppCardPairedRouteRoute: typeof LocalePartnerAppCardPairedRouteRouteWithChildren
  LocalePartnerAppCardDeviceRoleInstructionsRoute: typeof LocalePartnerAppCardDeviceRoleInstructionsRoute
  LocalePartnerAppCardImeiInstructionsRoute: typeof LocalePartnerAppCardImeiInstructionsRoute
  LocalePartnerAppCardImeiScanRoute: typeof LocalePartnerAppCardImeiScanRoute
  LocalePartnerAppCardInstructionsRoute: typeof LocalePartnerAppCardInstructionsRoute
  LocalePartnerAppCardMaxPriceRoute: typeof LocalePartnerAppCardMaxPriceRoute
  LocalePartnerAppCardPairScannerDeviceRoute: typeof LocalePartnerAppCardPairScannerDeviceRoute
  LocalePartnerAppCardPrepareScannerDeviceRoute: typeof LocalePartnerAppCardPrepareScannerDeviceRoute
  LocalePartnerAppCardQuoteVsEstimateRoute: typeof LocalePartnerAppCardQuoteVsEstimateRoute
  LocalePartnerAppCardSelectScannerDeviceRoute: typeof LocalePartnerAppCardSelectScannerDeviceRoute
  LocalePartnerAppCardUserInfoRoute: typeof LocalePartnerAppCardUserInfoRoute
}

const LocalePartnerAppCardRouteRouteChildren: LocalePartnerAppCardRouteRouteChildren =
  {
    LocalePartnerAppCardPairedRouteRoute:
      LocalePartnerAppCardPairedRouteRouteWithChildren,
    LocalePartnerAppCardDeviceRoleInstructionsRoute:
      LocalePartnerAppCardDeviceRoleInstructionsRoute,
    LocalePartnerAppCardImeiInstructionsRoute:
      LocalePartnerAppCardImeiInstructionsRoute,
    LocalePartnerAppCardImeiScanRoute: LocalePartnerAppCardImeiScanRoute,
    LocalePartnerAppCardInstructionsRoute:
      LocalePartnerAppCardInstructionsRoute,
    LocalePartnerAppCardMaxPriceRoute: LocalePartnerAppCardMaxPriceRoute,
    LocalePartnerAppCardPairScannerDeviceRoute:
      LocalePartnerAppCardPairScannerDeviceRoute,
    LocalePartnerAppCardPrepareScannerDeviceRoute:
      LocalePartnerAppCardPrepareScannerDeviceRoute,
    LocalePartnerAppCardQuoteVsEstimateRoute:
      LocalePartnerAppCardQuoteVsEstimateRoute,
    LocalePartnerAppCardSelectScannerDeviceRoute:
      LocalePartnerAppCardSelectScannerDeviceRoute,
    LocalePartnerAppCardUserInfoRoute: LocalePartnerAppCardUserInfoRoute,
  }

const LocalePartnerAppCardRouteRouteWithChildren =
  LocalePartnerAppCardRouteRoute._addFileChildren(
    LocalePartnerAppCardRouteRouteChildren,
  )

interface LocalePartnerAppRouteRouteChildren {
  LocalePartnerAppCardRouteRoute: typeof LocalePartnerAppCardRouteRouteWithChildren
  LocalePartnerAppIndexRoute: typeof LocalePartnerAppIndexRoute
}

const LocalePartnerAppRouteRouteChildren: LocalePartnerAppRouteRouteChildren = {
  LocalePartnerAppCardRouteRoute: LocalePartnerAppCardRouteRouteWithChildren,
  LocalePartnerAppIndexRoute: LocalePartnerAppIndexRoute,
}

const LocalePartnerAppRouteRouteWithChildren =
  LocalePartnerAppRouteRoute._addFileChildren(
    LocalePartnerAppRouteRouteChildren,
  )

interface LocalePartnerRouteRouteChildren {
  LocalePartnerAppRouteRoute: typeof LocalePartnerAppRouteRouteWithChildren
  LocalePartnerPeerRoute: typeof LocalePartnerPeerRoute
}

const LocalePartnerRouteRouteChildren: LocalePartnerRouteRouteChildren = {
  LocalePartnerAppRouteRoute: LocalePartnerAppRouteRouteWithChildren,
  LocalePartnerPeerRoute: LocalePartnerPeerRoute,
}

const LocalePartnerRouteRouteWithChildren =
  LocalePartnerRouteRoute._addFileChildren(LocalePartnerRouteRouteChildren)

interface LocaleRouteRouteChildren {
  LocalePartnerRouteRoute: typeof LocalePartnerRouteRouteWithChildren
  LocaleErrorRoute: typeof LocaleErrorRoute
}

const LocaleRouteRouteChildren: LocaleRouteRouteChildren = {
  LocalePartnerRouteRoute: LocalePartnerRouteRouteWithChildren,
  LocaleErrorRoute: LocaleErrorRoute,
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(
  LocaleRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LocaleRouteRoute: LocaleRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
